export default __webpack_public_path__ + "static/media/loading.e5321f18.gif";